import { Container } from '../components/layout/Primitives';

export default function Accessibility() {
  return (
    <div className="animate-fade-in">
      <Container style={{ padding: '3.5rem 1.5rem 4rem', maxWidth: '56rem' }}>
        <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>Accessibility</h1>
        <p style={{ marginTop: '1rem', opacity: 0.78, lineHeight: 1.75 }}>
          We aim to provide an inclusive storefront experience and continuously improve keyboard navigation, contrast,
          readable content structure, and assistive technology support.
        </p>
      </Container>
    </div>
  );
}
